import { useAppSelector } from "../../../../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_ID } from "../../../../../../store/selectors/requestAppSelector";
import { UI_ITOModuleSubTitle } from "../../../../../../UI_ITO/indexUI";
import { ApplicationStatusBaseInfo } from "../../../../../Ui/Application/ApplicationStatusBaseInfo/ApplicationStatusBaseInfo";
import classes from "../../style/connectedBanksStatusBlocks.module.css";
import { DocListWithSignInfoForDownload } from "../../../../DocListForDownload/DocListWithSignInfo/DocListWithSignInfoForDownload";

export const StatusBaseInfoWithSignDocInfo = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  return (
    <div>
      <ApplicationStatusBaseInfo
        appNumber={data.id}
        status={data.status.title}
      />
      <UI_ITOModuleSubTitle
        className={classes.sectionDocHeader}
        title={"Документы"}
      />

      <DocListWithSignInfoForDownload />
    </div>
  );
};
